import Gauge from '@/components/Gauge';
import { toFactor } from '@/utilities/formatting';

export interface Props {
  portfolioPE: number;
  portfolioName: string;
  marketPE: number;
  marketName: string;
}

const keys = ['portfolio', 'market'];

const PERatioGauge = ({
  portfolioPE,
  portfolioName,
  marketPE,
  marketName,
}: Props) => {
  const entities = {
    [keys[0]]: portfolioPE,
    [keys[1]]: marketPE,
  };
  const entityTitles = {
    [keys[0]]: portfolioName,
    [keys[1]]: marketName,
  };
  return (
    <Gauge
      title="PE Ratio"
      entityTitles={entityTitles}
      keys={keys}
      entities={entities}
      formatter={(value: number | null) =>
        value !== null ? toFactor(value, 1) : 'n/a'
      }
      numTicks={6}
      from={0}
      to={60}
      flip={true}
    />
  );
};

export default PERatioGauge;
